import React from "react";
import { Box, Card, Grid, Skeleton, Stack } from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

export const NewsDetailsSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Breadcrumb Skeleton */}
      <Skeleton variant="text" width={220} height={24} sx={{ mb: 3 }} />

      {/* Header Skeleton Card */}
      <Card
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: borderRadiusPx.xl,
          backgroundColor: colors.dashboard.cardBg,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          boxShadow: customShadows.cardFlat,
          mb: 4,
        }}
      >
        <Stack spacing={2}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Skeleton variant="rounded" width={110} height={24} sx={{ borderRadius: borderRadiusPx.pill }} />
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={90} height={20} />
          </Stack>
          <Skeleton variant="text" width="90%" height={48} />
          <Skeleton variant="text" width="60%" height={48} />
          <Stack direction="row" spacing={2} alignItems="center" sx={{ pt: 1 }}>
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="text" width={140} height={24} />
          </Stack>
        </Stack>
      </Card>

      {/* Main Content & Sidebar Skeleton Grid */}
      <Grid container spacing={4}>
        <Grid item xs={12} lg={8}>
          {/* Cover Image Skeleton */}
          <Skeleton
            variant="rectangular"
            height={380}
            sx={{
              borderRadius: borderRadiusPx.xl,
              mb: 3.5,
              width: "100%",
            }}
          />

          {/* Body Text Paragraph Skeletons */}
          <Card
            sx={{
              p: { xs: 3, sm: 4 },
              borderRadius: borderRadiusPx.xl,
              backgroundColor: colors.dashboard.cardBg,
              border: `1px solid ${colors.dashboard.cardBorder}`,
              boxShadow: customShadows.cardFlat,
            }}
          >
            <Stack spacing={2}>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="70%" height={24} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" height={100} sx={{ borderRadius: borderRadiusPx.lg, mb: 2 }} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
              <Skeleton variant="text" width="85%" height={24} />
            </Stack>
          </Card>
        </Grid>

        {/* Sidebar Skeleton */}
        <Grid item xs={12} lg={4}>
          <Card
            sx={{
              p: 3,
              borderRadius: borderRadiusPx.xl,
              backgroundColor: colors.dashboard.cardBg,
              border: `1px solid ${colors.dashboard.cardBorder}`,
              boxShadow: customShadows.cardFlat,
              mb: 3,
            }}
          >
            <Skeleton variant="text" width={140} height={28} sx={{ mb: 2 }} />
            <Stack spacing={2}>
              {Array.from({ length: 3 }).map((_, i) => (
                <Stack direction="row" spacing={2} key={i} alignItems="center">
                  <Skeleton variant="rounded" width={64} height={64} sx={{ borderRadius: borderRadiusPx.md }} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="50%" height={16} />
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewsDetailsSkeleton;
